import { motion } from 'framer-motion';

const ScaleFade = ({ children, ...rest }) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.8 }}
    animate={{ opacity: 1, scale: 1 }}
    exit={{ opacity: 0, scale: 0.8 }}
    {...rest}
  >
    {children}
  </motion.div>
);

export default ScaleFade;
